import React, { useEffect, useMemo, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stack,
  Alert,
  Chip,
} from '@mui/material';

/**
 * CategoryAssignModal 컴포넌트
 *
 * Props:
 * @param {boolean} open - 모달 열림 여부 [Required]
 * @param {function} onClose - 닫기 핸들러 [Required]
 * @param {Array<{ key: string, label: string, isActive: boolean }>} categories - 사용 가능한 카테고리 목록 [Required]
 * @param {Array<string>|string|null|undefined} currentCategoryKeys - 현재 선택된 카테고리 키 배열 [Optional]
 * @param {function} onSubmit - 선택 결과 제출 (keys[]|null) [Required]
 *
 *
 * Example usage:
 * <CategoryAssignModal open={open} onClose={...} categories={categories} currentCategoryKey={collection.categoryKey} onSubmit={(key)=>...} onCreateCategory={(k,l)=>...} />
 */
function CategoryAssignModal({ open, onClose, categories, currentCategoryKeys = [], onSubmit }) {
  const [selectedKeys, setSelectedKeys] = useState(Array.isArray(currentCategoryKeys) ? currentCategoryKeys : (currentCategoryKeys ? [currentCategoryKeys] : []));
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setSelectedKeys(Array.isArray(currentCategoryKeys) ? currentCategoryKeys : (currentCategoryKeys ? [currentCategoryKeys] : []));
      setError('');
    }
  }, [open, currentCategoryKeys]);

  const activeCategories = useMemo(() => (categories || []).filter((c) => c.isActive !== false), [categories]);

  const handleSave = async () => {
    try {
      await onSubmit(selectedKeys && selectedKeys.length > 0 ? selectedKeys : []);
      onClose();
    } catch (e) {
      setError(e.message || '저장 중 오류가 발생했습니다.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>카테고리 지정</DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Box>
            <FormControl fullWidth>
              <InputLabel id="category-select-label">카테고리 (복수 선택 가능)</InputLabel>
              <Select
                labelId="category-select-label"
                multiple
                label="카테고리 (복수 선택 가능)"
                value={selectedKeys}
                onChange={(e) => setSelectedKeys(e.target.value)}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {(selected || []).map((value) => {
                      const cat = activeCategories.find((c) => c.key === value);
                      const label = (cat?.labels && (cat.labels.ko || cat.labels.en)) || value;
                      return <Chip key={value} label={label} />;
                    })}
                  </Box>
                )}
              >
                {activeCategories.map((cat) => {
                  const display = (cat.labels && (cat.labels.ko || cat.labels.en)) || cat.key;
                  return (
                    <MenuItem key={cat.key} value={cat.key}>
                      {display} ({cat.key})
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>

          
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button variant="contained" onClick={handleSave}>저장</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CategoryAssignModal;


